import {useMatches} from 'react-router';
import {RouteHandle} from '@/routes';

export const useRouteKey = () => {
  const matches = useMatches();

  // Get the last match (most specific route)
  const currentMatch = matches[matches.length - 1];

  const handle = currentMatch.handle as RouteHandle | undefined;

  return {
    pathname: currentMatch.pathname,
    routeKey: handle?.routeKey || 'unknown',
  };
};
